export default __webpack_public_path__ + "static/media/smartwatch.c8513a7e.jpg";